import { SET_INVESTOR_RM_ID } from "../types/sessionData";

export const setInvestorRmId =
    (investorRmId: string): { type: string; investorRmId: string } => {
        return {
            type: SET_INVESTOR_RM_ID,
            investorRmId,
        };
    };